import { render } from "./NovaManualMrp.vue?vue&type=template&id=615dc61d&scoped=true"
import script from "./NovaManualMrp.vue?vue&type=script&lang=js"
export * from "./NovaManualMrp.vue?vue&type=script&lang=js"

import "./NovaManualMrp.vue?vue&type=style&index=0&id=615dc61d&scoped=true&lang=css"
import "./NovaManualMrp.vue?vue&type=style&index=1&id=615dc61d&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615dc61d"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QSelect,QToggle,QTable,QImg,QInput,QPagination,QTd,QBtn,QTooltip,QPopupProxy,QDate});qInstall(script, 'directives', {ClosePopup});
